import { Component, Injector, OnDestroy, OnInit} from '@angular/core';
import { JSProxyService } from "../../services/jsproxy.service";
import { BaseComponentWithDialog } from "../admin-panel/base-admin-panel/base-component-with-dialog";
import { ServiceDialogBaseComponent } from "./service-dialog-base/service-dialog-base.component";
import { CompletedWorksDialogBaseComponent } from "./completed-works-dialog-base/completed-works-dialog-base.component";
import { ServiceTaskService, ServiceTaskModel } from "../../services/servicetask.service";
import { CompletedWorksModel, CompletedWorksService } from "../../services/completedworks.service";

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.css'],
    standalone: false
})
export class ServiceComponent extends BaseComponentWithDialog implements OnInit,OnDestroy
{
    jsProxy: JSProxyService;
    service: ServiceTaskService;
    serviceCompletedWorks: CompletedWorksService;

    public selected: string;
    private shouldOpenCompletedWorksListAfterSave: boolean = false;

    constructor(protected injector: Injector)
    {
        super(injector);
        this.jsProxy = injector.get(JSProxyService);

        this.service = injector.get(ServiceTaskService);
        this.serviceCompletedWorks = injector.get(CompletedWorksService);
    }
    ngOnInit()
    {
        this.selected = "service_list";
        this.jsProxy.registerComponent("ServiceTaskEditor", this, "");
    }
    ngOnDestroy()
    {
        this.jsProxy.unRegisterComponent("ServiceTaskEditor");
    }

    public select(name: string) {
        this.selected = name;
    }

    public isSelected(name: string) {
        return name == this.selected;
    }

    public createServiceTask(objectId: number, objectName: string, odo: number, taho: number)
    {
        this.prepareModal(ServiceDialogBaseComponent);

        var model = new ServiceTaskModel();
        model.ObjectId = objectId;
        model.ObjectName = objectName;
        model.Odometr = odo;
        model.WorkTime = taho;

        this.componentRef.instance.open(model);
        this.componentRef.instance.updateFromJs(model);
    }

    public updateServiceTask(Id: number, objectName: string)
    {
        this.prepareModal(ServiceDialogBaseComponent);

        this.service.get(Id).subscribe(model => {
            model.ObjectName = objectName;
            this.componentRef.instance.open(model);
            this.componentRef.instance.updateFromJs(model);
        });
    }
    public deleteServiceTask(Id: number)
    {
        this.service.delete(Id).subscribe(model => { });
    }
    /////////////////////////////////////////////////////////////
    public createCompletedWork(objectId: number, objectName: string, serviceTasks: number[], odo:number, taho: number)
    {
        this.prepareModal(CompletedWorksDialogBaseComponent);
        this.shouldOpenCompletedWorksListAfterSave = true;

        var model = new CompletedWorksModel();
        model.ObjectId = objectId;
        model.ObjectName = objectName;
        model.Odometr = odo;
        model.WorkTime = taho;
        if (serviceTasks)
            model.ServiceTasks = serviceTasks;
        this.componentRef.instance.open(model);
    }

    public updateCompletedWork(Id: number, objectName: string)
    {
        this.prepareModal(CompletedWorksDialogBaseComponent);
        this.shouldOpenCompletedWorksListAfterSave = true;

        this.serviceCompletedWorks.get(Id).subscribe(model => {
            model.ObjectName = objectName;
            this.componentRef.instance.open(model);
        });
    }
    public deleteCompletedWork(Id: number)
    {
        this.serviceCompletedWorks.delete(Id).subscribe(model => {});
    }

    protected override Refresh() {
        if (this.shouldOpenCompletedWorksListAfterSave) {
            this.selected = "completed_works_list";
            this.shouldOpenCompletedWorksListAfterSave = false;
        }

        const componentLoadMap: { [key: string]: string } = {
            service_list: "PlannedTasksList",
            completed_works_list: "CompletedWorksList",
            service_report: "ServiceTasksReport",
            service_checkup: "ServiceCheckups"
        };

        const componentName = componentLoadMap[this.selected];
        if (componentName) {
            window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: componentName }));
        }
    }
}
